import * as React from "react";
/**
 * Context to pass down the ConfigProvider to components
 */ export const ConfigProviderContext = React.createContext(undefined);
